module.exports = __webpack_public_path__ + "img/icon-loader-ouri2.8b0a31fe.svg";